import type { Speaker } from "src/types";

export const mapFirstLastNames = (speakers: Array<Speaker>) => {
  return speakers.map((speaker) => {
    const isPartitioned = Boolean(speaker.first_name && speaker.last_name);
    const [firstName, ...rest] = speaker.name.split(" ");

    return {
      ...speaker,
      first_name: isPartitioned ? speaker.first_name : firstName,
      last_name: isPartitioned ? speaker.last_name : rest.join(" "),
    };
  });
};
